import {useState} from "react";
import {Button, Chip, Grid} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import CohortContent from "./CohortContent";
import {useGetAllUserGroupsQuery} from "../../../core/reducers/userGroup";
import {indexAfterDelete} from "../../Audience/audienceEditorModel";

const chipStyle = {borderRadius: "5px", height: '40px', width: '100%'};

/** Шаг "cohorts": вкладки когорт + настройки выбранной. */
export default function CohortStep({cohorts, validation, onChange, onAdd, onDelete}) {
    const [selected, setSelected] = useState(0);
    const {data: userGroups} = useGetAllUserGroupsQuery({env: "dev"});
    const currentIndex = Math.min(selected, cohorts.length - 1);
    const errorIndexes = new Set(validation.errorCohortIndexes);

    const add = () => {
        onAdd();
        setSelected(cohorts.length);
    };
    const remove = (index) => {
        onDelete(index);
        setSelected(indexAfterDelete(currentIndex, index));
    };

    return (
        <Grid container spacing={3} minWidth={800}>
            <Grid item xs={12} container spacing={1}>
                {cohorts.map((cohort, index) => (
                    <Grid item key={cohort.uuid || index} xs={2}>
                        <Chip
                            icon={errorIndexes.has(index) ? <WarningRoundedIcon/> : undefined}
                            style={chipStyle}
                            variant={index === currentIndex ? 'filled' : 'outlined'}
                            label={cohort.id}
                            color={errorIndexes.has(index) ? 'error' : 'warning'}
                            onClick={() => setSelected(index)}
                            onDelete={cohorts.length > 1 ? () => remove(index) : undefined}
                        />
                    </Grid>
                ))}
                <Grid item>
                    <Button variant={'outlined'} color={'info'} size={'small'} fullWidth style={{height: '40px'}} onClick={add}>
                        <AddIcon sx={{mr: 0.5}}/>
                        Add
                    </Button>
                </Grid>
            </Grid>
            <CohortContent
                key={cohorts[currentIndex].uuid || currentIndex}
                cohort={cohorts[currentIndex]}
                errors={validation.errors[currentIndex]}
                userGroups={userGroups}
                onChange={(field, value) => onChange(currentIndex, field, value)}
            />
        </Grid>
    );
}
